import React from 'react';

interface TimeIndicatorProps {
    left?: number;
}

export default function TimeIndicator({ left }: TimeIndicatorProps) {
    return (
        <div className="absolute z-20" style={{ left }}>
            <div className="-ml-1 flex w-2 flex-col items-center">
                <div className="bg-graph-blue h-2 w-2 rounded-full"></div>
                <div className="bg-graph-blue h-[72px] w-0.5"></div>
            </div>
        </div>
    );
}
